define.alias("ember-math-helpers/helpers/tanh", "preview-grid/helpers/tanh");